import { React, useRef, forwardRef, useState, useEffect, useImperativeHandle } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import CustomAlert from '../../Share/Normal/CustomAlert';

import SettingCountInput from '../../../Component/SettingComponent/SettingCountInput';

import FetchModule from '../../Share/Network/FetchModule';
import HoldingSettingCountInput from '../../../Component/SettingComponent/HoldingSettingCountInput';
import NewCountInput from '../../../Component/SettingComponent/NewCountInput';
import ReserveOpenCountInput from '../../../Component/SettingComponent/ReserveOpenCountInput';
import SaveCompleteModal from './Modal/SaveCompleModal';
// import NotRegistrationCardModal from '../../Share/Normal/NotRegistrationCardModal';
import MaxReserveQueue from '../../../Component/SettingComponent/MaxReserveQueueInput';
import PointInput from '../../../Component/SettingComponent/PointInput';
import LanguageSelectBox from '../../../Component/SettingComponent/LanguageSelectBox';

const SystemSettingView = forwardRef((props, ref) => {
  const history = useHistory();
  const { isDark, previewIsDark, applyIsDark, revertIsDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { languageMode, applyLanguage, revertLanguage, t } = useLanguage();
  const [pendingDarkMode, setPendingDarkMode] = useState(isDark ? 'dark' : 'light');
  const [pendingLanguage, setPendingLanguage] = useState(languageMode);
  const [rendering, setRendering] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [data, setData] = useState([{
    id: -1,
    reservationOpenTime: 0,
    reservationOpenTimeUnit: 'day',
    reservationChangeTime: 0,
    reservationChangeTimeUnit: 'min',
    reserveAvailableTime: 0,
    reserveAvailableTimeUnit: 'min',
    holdingAvailableTime: 0,
    holdingAvailableTimeUnit: 'min',
    minimumHoldingDay: 0,
    minimumHoldingDayUnit: 'day',
    maxReserveQueue: 0,
    isViewReserveList: false,
    isAvailableWeekendHolding: true,
    isAvailableAttendanceInApp: false,
    isOnlyTodayOpenExercise: false,
    isOpenPartnerGymSales: false,

    isUseAttendancePoint: false,
    isUseConsecutiveAttendancePoint: false,
    isUseWorkoutCompletePoint: false,
    isUseRejoinPoint: false,

    attendancePoint: 0,
    consecutiveAttendancePoint: 0,
    workoutCompletePoint: 0,
    rejoinPoint: 0,
  }]);

  const [isViewReserveList, setIsViewReserveList] = useState(false);
  const [isViewReserveCount, setIsViewReserveCount] = useState(false);
  const [isOpenTimeline, setIsOpenTimeline] = useState(false);
  const [isAvailableWeekendHolding, setIsAvailableWeekendHolding] = useState(true);
  const [isAvailableSaturdayHolding, setIsAvailableSaturdayHolding] = useState(true);
  const [isAvailableSundayHolding, setIsAvailableSundayHolding] = useState(true);
  const [isAvailableAttendanceInApp, setIsAvailableAttendanceInApp] = useState(false);
  const [isOnlyTodayOpenExercise, setIsOnlyTodayOpenExercise] = useState(false);
  const [isOpenPartnerGymSales, setIsOpenPartnerGymSales] = useState(false);
  const [isViewPartnerGymSetting, setIsViewPartnerGymSetting] = useState(false);
  // const [isRegistBillingInfo, setIsRegistBillingInfo] = useState(false);
  const [isUseNoShowPenalty, setIsUseNoShowPenalty] = useState(false);

  const [isUseFiveDayKakaoMessage, setIsUseFiveDayKakaoMessage] = useState(false);
  const [isUseThreeDayKakaoMessage, setIsUseThreeDayKakaoMessage] = useState(false);
  const [isUseOneDayKakaoMessage, setIsUseOneDayKakaoMessage] = useState(false);
  const [isDuplicateMembershipAlertLimited, setIsDuplicateMembershipAlertLimited] = useState(false);

  // const [isViewRegistrationCard, setIsViewRegistrationCard] = useState(false);
  const [isAutoAttendance, setIsAutoAttendance] = useState(false);

  const [isUseAttendancePoint, setIsUseAttendancePoint] = useState(false);
  const [isUseConsecutiveAttendancePoint, setIsUseConsecutiveAttendancePoint] = useState(false);
  const [isUseRejoinPoint, setIsUseRejoinPoint] = useState(false);
  const [isUseWorkoutCompletePoint, setIsUseWorkoutCompletePoint] = useState(false);

  const [attendancePoint, setAttendancePoint] = useState(0);
  const [consecutiveAttendancePoint, setConsecutiveAttendancePoint] = useState(0);
  const [workoutCompletePoint, setWorkoutCompletePoint] = useState(0);
  const [rejoinPoint, setRejoinPoint] = useState(0);

  const [maxReserveQueue, setMaxReserveQueue] = useState(0);
  const TopLevelRef = useRef();
  const ReservationOpenTimeRef = useRef();
  const ReservationCancelTimeRef = useRef();
  const ReservationAvailableTimeRef = useRef();
  const AttendanceDeadLineRef = useRef();
  const ReservationChangeTimeRef = useRef();
  const HoldingAvaliableRef = useRef();
  const MinimumHoldingRef = useRef();
  const MaximumHoldingRef = useRef();

  useImperativeHandle(ref, () => ({
    setOpacity: (val) => {
      TopLevelRef.current.style.opacity = val;
    },
    setZindex: (val) => {
      TopLevelRef.current.style.zIndex = val;
    },
    save: () => {
      save();
    }
  }))

  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('system/', 'GET');
        // console.log(responseData.data);
        if (responseData.status === 200) {
          // 아무런 데이터가 없을경우 //
          if (responseData.data[0] === null) {
            setData([{
              id: -1,
              reservationOpenTime: 0,
              reservationOpenTimeUnit: 'day',
              reservationChangeTime: 0,
              reservationChangeTimeUnit: 'min',
              reserveAvailableTime: 0,
              reserveAvailableTimeUnit: 'min',
              holdingAvailableTime: 0,
              holdingAvailableTimeUnit: 'day',
              minimumHoldingDay: 0,
              minimumHoldingDayUnit: 'day',
              maximumHoldingDay: 0,
              maximumHoldingDayUnit: 'day',
              maxReserveQueue: 0,
              isViewReserveList: false,
              isViewReserveCount: false,
              isOpenTimeline: false,
              isAvailableWeekendHolding: true,
              isAvailableSaturdayHolding: true,
              isAvailableSundayHolding: true,
              isAvailableAttendanceInApp: false,
              isOnlyTodayOpenExercise: false,
              isOpenPartnerGymSales: false,
              isUseFiveDayKakaoMessage: false,
              isUseThreeDayKakaoMessage: false,
              isUseOneDayKakaoMessage: false,
              isUseNoShowPenalty: false,
              isUseAutoAttendance: false,
              isDuplicateMembershipAlertLimited: false,

              isUseAttendancePoint: false,
              isUseConsecutiveAttendancePoint: false,
              isUseWorkoutCompletePoint: false,
              isUseRejoinPoint: false,

              attendancePoint: 0,
              consecutiveAttendancePoint: 0,
              workoutCompletePoint: 0,
              rejoinPoint: 0,
            }])

            setIsViewPartnerGymSetting(false);
          }
          // 데이터가 존재하는 경우
          else {
            setData(responseData.data);
            setIsViewPartnerGymSetting(responseData.data[0].isViewPartnerGymSetting);
          }
        }
        else if (responseData.status === 401) history.push('/');
        // else if (responseData.status !== 204) alert("시스템 정보를 불러오는데 실패하였습니다.\n잠시후 다시시도 해주세요");
      }
    )();
    return () => { revertIsDark(); revertLanguage(); };
  }, [history, rendering])

  useEffect(() => {
    // console.log(data[0])
    if (data[0].reservationOpenTimeUnit === 'min') ReservationOpenTimeRef.current.setValue(data[0].reservationOpenTime);
    else if (data[0].reservationOpenTimeUnit === 'time') ReservationOpenTimeRef.current.setValue(parseInt(data[0].reservationOpenTime / 60));
    else ReservationOpenTimeRef.current.setValue(parseInt((data[0].reservationOpenTime / 60) / 24));

    if (data[0].reservationChangeTimeUnit === 'min') ReservationChangeTimeRef.current.setValue(data[0].reservationChangeTime);
    else if (data[0].reservationChangeTimeUnit === 'time') ReservationChangeTimeRef.current.setValue(parseInt(data[0].reservationChangeTime / 60));
    else ReservationChangeTimeRef.current.setValue(parseInt((data[0].reservationChangeTime / 60) / 24));

    if (data[0].reserveAvailableTimeUnit === 'min') ReservationAvailableTimeRef.current.setValue(data[0].reserveAvailableTime);
    else if (data[0].reserveAvailableTimeUnit === 'time') ReservationAvailableTimeRef.current.setValue(parseInt(data[0].reserveAvailableTime / 60));
    else ReservationAvailableTimeRef.current.setValue(parseInt((data[0].reserveAvailableTime / 60) / 24));

    HoldingAvaliableRef.current.setValue(data[0].holdingAvailableTime);

    // ReservationOpenTimeRef.current.setUnit(data[0].reservationOpenTimeUnit);
    ReservationOpenTimeRef.current.setTime(data[0].reservationOpenStandardTime);
    ReservationChangeTimeRef.current.setUnit(data[0].reservationChangeTimeUnit);
    ReservationAvailableTimeRef.current.setUnit(data[0].reserveAvailableTimeUnit);

    MinimumHoldingRef.current.setValue(data[0].minimumHoldingDay);
    MaximumHoldingRef.current.setValue(data[0].maximumHoldingDay);

    setMaxReserveQueue(data[0].maxReserveQueue)

    setIsOpenTimeline(data[0].isOpenTimeline);
    setIsViewReserveList(data[0].isViewReserveList);
    setIsViewReserveCount(data[0].isViewReserveCount);
    setIsAvailableAttendanceInApp(data[0].isAvailableAttendanceInApp);
    setIsOnlyTodayOpenExercise(data[0].isOnlyTodayOpenExercise);
    setIsAvailableWeekendHolding(data[0].isAvailableWeekendHolding);
    setIsAvailableSaturdayHolding(data[0].isAvailableSaturdayHolding);
    setIsAvailableSundayHolding(data[0].isAvailableSundayHolding);
    setIsOpenPartnerGymSales(data[0].isOpenPartnerGymSales);
    // setIsRegistBillingInfo(data[0].isRegistBillingInfo);

    setIsUseFiveDayKakaoMessage(data[0].isUseFiveDayKakaoMessage);
    setIsUseThreeDayKakaoMessage(data[0].isUseThreeDayKakaoMessage);
    setIsUseOneDayKakaoMessage(data[0].isUseOneDayKakaoMessage);
    setIsUseNoShowPenalty(data[0].isUseNoShowPenalty);
    setIsAutoAttendance(data[0].isAutoAttendance);
    setIsDuplicateMembershipAlertLimited(data[0].isDuplicateMembershipAlertLimited);

    setIsUseAttendancePoint(data[0].isUseAttendancePoint);
    setIsUseConsecutiveAttendancePoint(data[0].isUseConsecutiveAttendancePoint);
    setIsUseRejoinPoint(data[0].isUseRejoinPoint);
    setIsUseWorkoutCompletePoint(data[0].isUseWorkoutCompletePoint);

    setAttendancePoint(data[0].attendancePoint);
    setConsecutiveAttendancePoint(data[0].consecutiveAttendancePoint);
    setWorkoutCompletePoint(data[0].workoutCompletePoint);
    setRejoinPoint(data[0].rejoinPoint);

  }, [data])

  //// 카카오 알림톡 설명 텍스트 결정 //
  //function decideKakaoText() {
  //  if (!isUseFiveDayKakaoMessage
  //    && !isUseThreeDayKakaoMessage
  //    && !isUseOneDayKakaoMessage) return t('system.kakaoAlertNone');
  //  else {
  //    let str = '';

  //    if (isUseFiveDayKakaoMessage) str += ',5';
  //    if (isUseThreeDayKakaoMessage) str += ',3';
  //    if (isUseOneDayKakaoMessage) str += ',1';

  //    return t('system.kakaoAlertActive', { days: str.slice(1) });
  //  }
  //}

  //// 카카오 알림톡 5일 클릭시 //
  //function onClickFiveDays() {
  //  if (!isRegistBillingInfo) {
  //    setIsViewRegistrationCard(true);
  //    return;
  //  }

  //  setIsUseFiveDayKakaoMessage(!isUseFiveDayKakaoMessage);
  //}

  //// 카카오 알림톡 3일 클릭시 //
  //function onClickThreeDays() {
  //  if (!isRegistBillingInfo) {
  //    setIsViewRegistrationCard(true);
  //    return;
  //  }

  //  setIsUseThreeDayKakaoMessage(!isUseThreeDayKakaoMessage);
  //}

  //// 카카오 알림톡 1일 클릭시 //
  //function onClickOneDays() {
  //  if (!isRegistBillingInfo) {
  //    setIsViewRegistrationCard(true);
  //    return;
  //  }

  //  setIsUseOneDayKakaoMessage(!isUseOneDayKakaoMessage);
  //}

  // // 예약 인원 명단 노출 변경시 //
  // function onClickIsViewReserveList() {
  //   if (isViewReserveList) {
  //     setIsViewReserveList(false);
  //     setIsViewReserveCount(false);
  //   }
  //   else setIsViewReserveList(true);
  // }

  //// 입력하기 버튼 클릭시 //
  //function onClickRegistrationCard() {
  //  const obj = {};

  //  obj.PCD_PAY_TYPE = 'card'
  //  obj.PCD_PAY_WORK = 'AUTH'
  //  obj.PCD_CARD_VER = '01';
  //  obj.PCD_PAYER_AUTHTYPE = 'sms';

  //  obj.callbackFunction = getResult;
  //  obj.clientKey = '0F44C92BFB07F1BE60C5235A7254316D';
  //  // obj.clientKey = 'test_DF55F29DA654A8CBC0F0A9DD4B556486';

  //  window.PaypleCpayAuthCheck(obj);
  //}

  //// 결제 이후 콜백 //
  //function getResult(res) {
  //  if (res.PCD_PAY_RST === 'success' && (res.PCD_PAY_CODE === '0000' || res.PCD_PAY_CODE === 'CDAU1000')) {
  //    let requestData = {
  //      billingKey: res.PCD_PAYER_ID,
  //      cardName: res.PCD_PAY_CARDNAME,
  //      cardNum: res.PCD_PAY_CARDNUM
  //    }

  //    const fetchModule = new FetchModule();
  //    (
  //      async () => {
  //        const responseData = await fetchModule.postDataVersion2('billing/registry', 'POST', requestData);

  //        if (responseData.status === 200) {
  //          alert(t('system.alertCardRegistered'));
  //          // setCountData({isRegistrationCard: true, validCount: countData.validCount, invalidCount: countData.invalidCount });
  //          setIsViewRegistrationCard(false);
  //          setIsRegistBillingInfo(true);
  //        }
  //      }
  //    )();
  //  }
  //  else {
  //    if (res.PCD_PAY_CODE === undefined) {
  //      alert(res.PCD_PAY_MSG);
  //    }
  //    else {
  //      alert('[' + res.PCD_PAY_CODE + ']' + ' ' + res.PCD_PAY_MSG);
  //    }
  //  }
  //}

  // 다크모드 토글 클릭시 - 즉시 미리보기 적용 (저장 전) //
  function onClickDarkMode() {
    const nextMode = pendingDarkMode === 'dark' ? 'light' : 'dark';
    setPendingDarkMode(nextMode);
    previewIsDark(nextMode);
  }

  // 저장하기 //
  function save() {
    let reservationOpenTime = ReservationOpenTimeRef.current.getValue();
    let reservationOpenStandardTime = ReservationOpenTimeRef.current.getTime();
    let reservationChangeTime = ReservationChangeTimeRef.current.getValue();
    let reservationAvailableTime = ReservationAvailableTimeRef.current.getValue();
    let reservationOpenTimeUnit = 'day';
    let reservationChangeTimeUnit = ReservationChangeTimeRef.current.getUnit();
    let reservationAvailableTimeUnit = ReservationAvailableTimeRef.current.getUnit();
    let holdingAvailableTime = HoldingAvaliableRef.current.getValue();
    let holdingAvailableTimeUnit = 'day';
    let minimumHoldingDay = MinimumHoldingRef.current.getValue();
    let minimumHoldingDayUnit = 'day';
    let maximumHoldingDay = MaximumHoldingRef.current.getValue();
    let maximumHoldingDayUnit = 'day';

    if (reservationOpenTimeUnit === '분') reservationOpenTimeUnit = 'min';
    else if (reservationOpenTimeUnit === '시간') reservationOpenTimeUnit = 'time';
    else reservationOpenTimeUnit = 'day';

    if (reservationChangeTimeUnit === 'hour') reservationChangeTimeUnit = 'time';

    if (reservationAvailableTimeUnit === 'hour') reservationAvailableTimeUnit = 'time';

    if (isUseNoShowPenalty && isAutoAttendance) {
      alert(t('system.alertNoShowAutoConflict'));
      return;
    }

    let newData = {
      id: data[0].id,
      reservationOpenTime: reservationOpenTime,
      reservationOpenStandardTime: reservationOpenStandardTime,
      reservationChangeTime: reservationChangeTime,
      reserveAvailableTime: reservationAvailableTime,
      reservationOpenTimeUnit: reservationOpenTimeUnit,
      reservationChangeTimeUnit: reservationChangeTimeUnit,
      reserveAvailableTimeUnit: reservationAvailableTimeUnit,
      // reserveAvailableTime: 0,
      // reserveAvailableTimeUnit: 'min',
      holdingAvailableTime: holdingAvailableTime,
      holdingAvailableTimeUnit: holdingAvailableTimeUnit,
      minimumHoldingDay: minimumHoldingDay,
      minimumHoldingDayUnit: minimumHoldingDayUnit,
      maximumHoldingDay: maximumHoldingDay === undefined ? 0 : maximumHoldingDay,
      maximumHoldingDayUnit: maximumHoldingDayUnit,

      isViewReserveList: isViewReserveList === undefined ? false : isViewReserveList,
      isViewReserveCount: isViewReserveCount === undefined ? false : isViewReserveCount,
      isOpenTimeline: isOpenTimeline === undefined ? false : isOpenTimeline,
      isAvailableAttendanceInApp: isAvailableAttendanceInApp,
      isOnlyTodayOpenExercise: isOnlyTodayOpenExercise,
      isAvailableWeekendHolding: isAvailableWeekendHolding,
      isAvailableSaturdayHolding: isAvailableSaturdayHolding,
      isAvailableSundayHolding: isAvailableSundayHolding,
      isOpenPartnerGymSales: isOpenPartnerGymSales,
      isUseFiveDayKakaoMessage: isUseFiveDayKakaoMessage === undefined ? false : isUseFiveDayKakaoMessage,
      isUseThreeDayKakaoMessage: isUseThreeDayKakaoMessage === undefined ? false : isUseThreeDayKakaoMessage,
      isUseOneDayKakaoMessage: isUseOneDayKakaoMessage === undefined ? false : isUseOneDayKakaoMessage,
      isUseNoShowPenalty: isUseNoShowPenalty === undefined ? false : isUseNoShowPenalty,
      isAutoAttendance: isAutoAttendance === undefined ? false : isAutoAttendance,
      maxReserveQueue: maxReserveQueue,
      isDuplicateMembershipAlertLimited: isDuplicateMembershipAlertLimited,

      isUseAttendancePoint: isUseAttendancePoint,
      isUseConsecutiveAttendancePoint: isUseConsecutiveAttendancePoint,
      isUseWorkoutCompletePoint: isUseWorkoutCompletePoint,
      isUseRejoinPoint: isUseRejoinPoint,

      attendancePoint: attendancePoint,
      consecutiveAttendancePoint: consecutiveAttendancePoint,
      workoutCompletePoint: workoutCompletePoint,
      rejoinPoint: rejoinPoint
    }
    // console.log(newData);
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.patchData('system/save', 'POST', newData);

        if (responseData.status === 200) {
          applyIsDark(pendingDarkMode);
          applyLanguage(pendingLanguage);
          setIsSaved(true);
          setData(responseData.data);
        }
        else if (responseData.status === 401) history.push('/');
        else if (responseData.status !== 204) alert(t('system.alertSaveFailed'));
      }
    )();
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      {isSaved && <SaveCompleteModal closeFn={() => setIsSaved(false)} />}
      {/*{isViewRegistrationCard && <NotRegistrationCardModal division='Notice' setIsViewModal={setIsViewRegistrationCard} onClickRegistCard={onClickRegistrationCard} />}*/}
      <InfoBoxWrapper>
        <Catrgory backgroundColor={theme.category1}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categorySystem')}</Text>
        </Catrgory>
        <InfoBox width={964}>
          <ComponentColumnWrapper>
            <ComponentRowWrapper>
              <SelectTitleWrapper>
                <Title>{t('system.languageTitle')}</Title>
                <Explanation>{t('system.languageDesc')}</Explanation>
              </SelectTitleWrapper>
              <SelectComponentWrappper style={{ marginLeft: '30px' }}>
                <LanguageSelectBox onChangeLanguage={(val) => setPendingLanguage(val)} />
              </SelectComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentRowWrapper>
              <SlideTitleWrapper>
                <Title>{t('system.darkModeTitle')}</Title>
                <Explanation>{t('system.darkModeDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={onClickDarkMode}>
                <SlideOutBox isClicked={pendingDarkMode === 'dark'}>
                  <SlideInBox isClicked={pendingDarkMode === 'dark'} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{pendingDarkMode === 'dark' ? t('system.active') : t('system.inactive')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
        </InfoBox>
      </InfoBoxWrapper>
      <InfoBoxWrapper>
        <Catrgory backgroundColor={theme.category2}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categoryClasses')}</Text>
        </Catrgory>
        <InfoBox width={964}>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <Title>{t('system.bookingOpenTitle')}</Title>
              <Explanation>{t('system.bookingOpenDesc')}</Explanation>
              {/* <SettingCountInput ref={ReservationOpenTimeRef} text='전부터' /> */}
              <ReserveOpenCountInput ref={ReservationOpenTimeRef} />
            </ComponentWrapper>
            <ComponentRowWrapper style={{ marginTop: '13px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.waitlistTitle')}</Title>
                <Explanation>{t('system.waitlistDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper>
                <MaxReserveQueue value={maxReserveQueue} setValue={setMaxReserveQueue} />
              </SlideComponentWrappper>
            </ComponentRowWrapper>
            <ComponentRowWrapper style={{ marginTop: '35px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.autoAttendanceTitle')}</Title>
                <Explanation>{t('system.autoAttendanceDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => setIsAutoAttendance(!isAutoAttendance)}>
                <SlideOutBox isClicked={isAutoAttendance}>
                  <SlideInBox isClicked={isAutoAttendance} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isAutoAttendance ? t('system.auto') : t('system.manual')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <Title>{t('system.bookingCutoffTitle')}</Title>
              <Explanation>{t('system.bookingCutoffDesc')}</Explanation>
              <SettingCountInput ref={ReservationAvailableTimeRef} text={t('system.beforeTime')} />
            </ComponentWrapper>

            <ComponentRowWrapper style={{ marginTop: '32px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.bookingListTitle')}</Title>
                <Explanation>{t('system.bookingListDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => setIsViewReserveList(!isViewReserveList)}>
                <SlideOutBox isClicked={isViewReserveList}>
                  <SlideInBox isClicked={isViewReserveList} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isViewReserveList ? t('system.public') : t('system.private')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>

            <ComponentRowWrapper style={{ marginTop: '34px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.noShowTitle')}</Title>
                <Explanation>{t('system.noShowDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => setIsUseNoShowPenalty(!isUseNoShowPenalty)}>
                <SlideOutBox isClicked={isUseNoShowPenalty}>
                  <SlideInBox isClicked={isUseNoShowPenalty} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isUseNoShowPenalty ? t('system.active') : t('system.inactive')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <Title>{t('system.cancelCutoffTitle')}</Title>
              <Explanation>{t('system.cancelCutoffDesc')}</Explanation>
              <SettingCountInput ref={ReservationChangeTimeRef} text={t('system.beforeTime')} />
            </ComponentWrapper>

            <ComponentRowWrapper style={{ marginTop: '32px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.bookingCountTitle')}</Title>
                <Explanation>{t('system.bookingCountDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => setIsViewReserveCount(!isViewReserveCount)}>
                <SlideOutBox isClicked={isViewReserveCount}>
                  <SlideInBox isClicked={isViewReserveCount} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isViewReserveCount ? t('system.public') : t('system.private')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>

            <ComponentRowWrapper style={{ marginTop: '32px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.appAttendanceTitle')}</Title>
                <Explanation>{t('system.appAttendanceDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => setIsAvailableAttendanceInApp(!isAvailableAttendanceInApp)}>
                <SlideOutBox isClicked={isAvailableAttendanceInApp}>
                  <SlideInBox isClicked={isAvailableAttendanceInApp} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isAvailableAttendanceInApp ? t('system.on') : t('system.off')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
        </InfoBox>
      </InfoBoxWrapper>
      <InfoBoxWrapper>
        <Catrgory backgroundColor={theme.category3}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categoryMembership')}</Text>
        </Catrgory>
        <InfoBox width={964}>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <Title>{t('system.holdDeadlineTitle')}</Title>
              <Explanation>{t('system.holdDeadlineDesc')}</Explanation>
              <HoldingSettingCountInput ref={HoldingAvaliableRef} text={t('system.daysBefore')} />
            </ComponentWrapper>
            <ComponentRowWrapper style={{ marginTop: '32px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.weekendHoldTitle')}</Title>
                <Explanation>{t('system.weekendHoldDesc')}</Explanation>
              </SlideTitleWrapper>
              <GenderBoxWrapper>
                <GenderBox isClicked={isAvailableSaturdayHolding} onClick={() => setIsAvailableSaturdayHolding(!isAvailableSaturdayHolding)}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isAvailableSaturdayHolding ? theme.background : theme.text} cursor='pointer'>{t('system.saturday')}</Text>
                </GenderBox>
                <GenderBox isClicked={isAvailableSundayHolding} onClick={() => setIsAvailableSundayHolding(!isAvailableSundayHolding)}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isAvailableSundayHolding ? theme.background : theme.text} cursor='pointer'>{t('system.sunday')}</Text>
                </GenderBox>
              </GenderBoxWrapper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <Title>{t('system.minHoldTitle')}</Title>
              <Explanation>{t('system.minHoldDesc')}</Explanation>
              <HoldingSettingCountInput ref={MinimumHoldingRef} text={t('system.daysMin')} />
            </ComponentWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentWrapper>
              <Title>{t('system.maxHoldTitle')}</Title>
              <Explanation>{t('system.maxHoldDesc')}</Explanation>
              <HoldingSettingCountInput ref={MaximumHoldingRef} text={t('system.daysMax')} />
            </ComponentWrapper>
          </ComponentColumnWrapper>
        </InfoBox>
      </InfoBoxWrapper>
      {/*<InfoBoxWrapper>
        <Catrgory backgroundColor={theme.category4}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categoryNotification')}</Text>
        </Catrgory>
        <InfoBox width={964}>
          <ComponentColumnWrapper>
            <ComponentRowWrapper style={{ marginTop: '13px' }}>
              <SlideTitleWrapper style={{ width: '170px' }}>
                <Title>{t('system.kakaoTitle')}</Title>
                <Explanation>{decideKakaoText()}</Explanation>
                <Text style={{ marginTop: '8px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.pointRed}>{t('system.kakaoCharge')}</Text>
              </SlideTitleWrapper>
              <KakaoDayBoxWrapper style={{ marginTop: '-24px', marginLeft: '6px' }}>
                <KakaoDayBox isClicked={isUseFiveDayKakaoMessage} onClick={onClickFiveDays}>{t('system.fiveDays')}</KakaoDayBox>
                <KakaoDayBox isClicked={isUseThreeDayKakaoMessage} onClick={onClickThreeDays}>{t('system.threeDays')}</KakaoDayBox>
                <KakaoDayBox isClicked={isUseOneDayKakaoMessage} onClick={onClickOneDays}>{t('system.oneDay')}</KakaoDayBox>
              </KakaoDayBoxWrapper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>

          <ComponentColumnWrapper>
            <ComponentRowWrapper style={{ marginTop: '13px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.duplicatePassTitle')}</Title>
                <Explanation>{t('system.duplicatePassDesc1')}</Explanation>
                <Explanation>{t('system.duplicatePassDesc2')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper style={{ marginTop: '-24px' }} onClick={() => setIsDuplicateMembershipAlertLimited(!isDuplicateMembershipAlertLimited)}>
                <SlideOutBox isClicked={isDuplicateMembershipAlertLimited}>
                  <SlideInBox isClicked={isDuplicateMembershipAlertLimited} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isDuplicateMembershipAlertLimited ? t('system.active') : t('system.inactive')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
        </InfoBox>
      </InfoBoxWrapper>*/}

      <InfoBoxWrapper>
        <Catrgory backgroundColor={theme.category5}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categoryPoint')}</Text>
        </Catrgory>
        <InfoBox width={964}>
          <ComponentColumnWrapper style={{ marginTop: '13px' }}>
            <ComponentRowWrapper>
              <ComponentColumnWrapper style={{ gap: '4px', marginRight: '50px' }}>
                <SlideTitleWrapper style={{ gap: '0px', width: '290px', minWidth: '290px', marginBottom: '5px' }}>
                  <Title>{t('system.attendancePointTitle')}</Title>
                  <Explanation>{t('system.attendancePointDesc', { count: attendancePoint })}</Explanation>
                </SlideTitleWrapper>
                <ComponentRowWrapper style={{ justifyContent: 'space-between', width: '290px' }}>
                  <PointInput value={attendancePoint} setValue={setAttendancePoint} />
                  <SlideComponentWrappper style={{ width: '113px' }} onClick={() => setIsUseAttendancePoint(!isUseAttendancePoint)}>
                    <SlideOutBox isClicked={isUseAttendancePoint}>
                      <SlideInBox isClicked={isUseAttendancePoint} />
                    </SlideOutBox>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isUseAttendancePoint ? t('system.active') : t('system.inactive')}</Text>
                  </SlideComponentWrappper>
                </ComponentRowWrapper>
              </ComponentColumnWrapper>

              <ComponentColumnWrapper style={{ gap: '4px', marginRight: '50px'  }}>
                <SlideTitleWrapper style={{ gap: '0px', width: '290px', minWidth: '290px', marginBottom: '5px' }}>
                  <Title>{t('system.streakPointTitle')}</Title>
                  <Explanation>{t('system.streakPointDesc', { count: consecutiveAttendancePoint })}</Explanation>
                </SlideTitleWrapper>
                <ComponentRowWrapper style={{ justifyContent: 'space-between', width: '290px' }}>
                  <PointInput value={consecutiveAttendancePoint} setValue={setConsecutiveAttendancePoint} />
                  <SlideComponentWrappper style={{ width: '113px' }} onClick={() => setIsUseConsecutiveAttendancePoint(!isUseConsecutiveAttendancePoint)}>
                    <SlideOutBox isClicked={isUseConsecutiveAttendancePoint}>
                      <SlideInBox isClicked={isUseConsecutiveAttendancePoint} />
                    </SlideOutBox>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isUseConsecutiveAttendancePoint ? t('system.active') : t('system.inactive')}</Text>
                  </SlideComponentWrappper>
                </ComponentRowWrapper>
              </ComponentColumnWrapper>

              <ComponentColumnWrapper style={{ gap: '4px' }}>
                <SlideTitleWrapper style={{ gap: '0px', width: '290px', minWidth: '290px', marginBottom: '5px' }}>
                  <Title>{t('system.workoutPointTitle')}</Title>
                  <Explanation>{t('system.workoutPointDesc', { count: workoutCompletePoint })}</Explanation>
                </SlideTitleWrapper>
                <ComponentRowWrapper style={{ justifyContent: 'space-between', width: '290px' }}>
                  <PointInput value={workoutCompletePoint} setValue={setWorkoutCompletePoint} />
                  <SlideComponentWrappper style={{ width: '113px' }} onClick={() => setIsUseWorkoutCompletePoint(!isUseWorkoutCompletePoint)}>
                    <SlideOutBox isClicked={isUseWorkoutCompletePoint}>
                      <SlideInBox isClicked={isUseWorkoutCompletePoint} />
                    </SlideOutBox>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isUseWorkoutCompletePoint ? t('system.active') : t('system.inactive')}</Text>
                  </SlideComponentWrappper>
                </ComponentRowWrapper>
              </ComponentColumnWrapper>

            </ComponentRowWrapper>

            <ComponentRowWrapper style={{ marginTop: '34px' }}>
              <ComponentColumnWrapper style={{ gap: '4px' }}>
                <SlideTitleWrapper style={{ gap: '0px', width: '290px', minWidth: '290px', marginBottom: '5px' }}>
                  <Title>{t('system.rejoinPointTitle')}</Title>
                  <Explanation>{t('system.rejoinPointDesc', { count: rejoinPoint })}</Explanation>
                </SlideTitleWrapper>
                <ComponentRowWrapper style={{ justifyContent: 'space-between', width: '290px' }}>
                  <PointInput value={rejoinPoint} setValue={setRejoinPoint} />
                  <SlideComponentWrappper style={{ width: '113px' }} onClick={() => setIsUseRejoinPoint(!isUseRejoinPoint)}>
                    <SlideOutBox isClicked={isUseRejoinPoint}>
                      <SlideInBox isClicked={isUseRejoinPoint} />
                    </SlideOutBox>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isUseRejoinPoint ? t('system.active') : t('system.inactive')}</Text>
                  </SlideComponentWrappper>
                </ComponentRowWrapper>
              </ComponentColumnWrapper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
          {/* <ComponentColumnWrapper>
            <ComponentRowWrapper style={{ marginTop: '13px' }}>
              <SlideTitleWrapper>
                <Title>타임라인 운동 당일 오픈</Title>
                <Explanation>운동을 당일에 오픈해드립니다</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => setIsOnlyTodayOpenExercise(!isOnlyTodayOpenExercise)}>
                <SlideOutBox isClicked={isOnlyTodayOpenExercise}>
                  <SlideInBox isClicked={isOnlyTodayOpenExercise} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isOnlyTodayOpenExercise ? '당일 오픈' : '항상 오픈'}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper> */}
        </InfoBox>
      </InfoBoxWrapper>

      <InfoBoxWrapper>
        <Catrgory backgroundColor={theme.category1}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categoryLinko')}</Text>
        </Catrgory>
        <InfoBox width={964}>
          <ComponentColumnWrapper>
            <ComponentRowWrapper style={{ marginTop: '13px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.timelinePermTitle')}</Title>
                <Explanation>{t('system.timelinePermDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => setIsOpenTimeline(!isOpenTimeline)}>
                <SlideOutBox isClicked={isOpenTimeline}>
                  <SlideInBox isClicked={isOpenTimeline} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isOpenTimeline ? t('system.on') : t('system.off')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
          <ComponentColumnWrapper>
            <ComponentRowWrapper style={{ marginTop: '13px' }}>
              <SlideTitleWrapper>
                <Title>{t('system.timelineOpenTitle')}</Title>
                <Explanation>{t('system.timelineOpenDesc')}</Explanation>
              </SlideTitleWrapper>
              <SlideComponentWrappper onClick={() => setIsOnlyTodayOpenExercise(!isOnlyTodayOpenExercise)}>
                <SlideOutBox isClicked={isOnlyTodayOpenExercise}>
                  <SlideInBox isClicked={isOnlyTodayOpenExercise} />
                </SlideOutBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isOnlyTodayOpenExercise ? t('system.todayOpen') : t('system.alwaysOpen')}</Text>
              </SlideComponentWrappper>
            </ComponentRowWrapper>
          </ComponentColumnWrapper>
        </InfoBox>
      </InfoBoxWrapper>
      {
        isViewPartnerGymSetting &&
        <InfoBoxWrapper>
          <Catrgory backgroundColor={theme.category5}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.background} cursor='default'>{t('system.categoryPartnerGym')}</Text>
          </Catrgory>
          <InfoBox width={964}>
            <ComponentColumnWrapper>
              <ComponentRowWrapper style={{ marginTop: '13px' }}>
                <SlideTitleWrapper style={{ width: '152px' }}>
                  <Title>{t('system.partnerGymSalesTitle')}</Title>
                  <Explanation>{t('system.partnerGymSalesDesc1')}</Explanation>
                  <Explanation>{t('system.partnerGymSalesDesc2')}</Explanation>
                </SlideTitleWrapper>
                <SlideComponentWrappper style={{ marginTop: '-24px' }} onClick={() => setIsOpenPartnerGymSales(!isOpenPartnerGymSales)}>
                  <SlideOutBox isClicked={isOpenPartnerGymSales}>
                    <SlideInBox isClicked={isOpenPartnerGymSales} />
                  </SlideOutBox>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{isOpenPartnerGymSales ? t('system.public') : t('system.private')}</Text>
                </SlideComponentWrappper>
              </ComponentRowWrapper>
            </ComponentColumnWrapper>
          </InfoBox>
        </InfoBoxWrapper>
      }
    </TopLevelWrapper>
  )
})

export default SystemSettingView;

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 1035px;
  // width: 1020px;
  // width: 964px;
  // height: 258px;

  // opacity: 0;
  // z-index: -3000;

  // margin: -800px 0 545px 0;
  // padding: 28px 28px 28px 28px;
  margin-top: 20px;
  margin-bottom: 260px;

  // gap: 80px;
  gap: 33px;

  // border-radius: 30px;
  // box-shadow: 0px 40px 50px rgba(240, 232, 227, 0);
  // background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const Catrgory = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  height: 27px;
  padding: 0px 10px;

  border-radius: 5px 5px 0px 0px;
  background-color: ${props => props.backgroundColor};
`;

const InfoBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 28px;

  width: ${props => props.width}px;
  
  gap: 30px;

  border-radius: 0px 16px 16px 16px;
  box-shadow: 30px 16px 30px rgba(142, 140, 138, 0);
  // box-shadow: 30px 16px 30px red;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const ComponentColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  // align-items: center;

  // gap: 32px;

  // margin-top: 28px;
`;

const ComponentRowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 300px;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 300px;
  // gap: 8px;
  gap: 4px;
`;

const SlideTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 155px;
  min-width: 155px;

  gap: 4px;
`;

const SelectTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const SlideComponentWrappper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-left: 13px;
  gap: 8px;

  transition: all 0.3s ease-in-out;
`;

const SelectComponentWrappper = styled.div`
  display: flex;

  justify-content: flex-start;
  align-items: center;
`;

const SlideOutBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 69px;
  height: 30px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 8px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const SlideInBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-left: ${props => props.isClicked ? '41px' : '2px'};

  width: 26px;
  height: 26px;

  border-radius: 6px;
  background-color: ${props => props.isClicked ? props.theme.white : props.theme.gray};

  transition: all 0.3s ease-in-out;
`;

const KakaoDayBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 6px;
`;

const GenderBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  gap: 5px;
`;

const GenderBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  height: 30px;

  padding: 0 10px 0 10px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 8px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const KakaoDayBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 8px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: ${props => props.isClicked ? props.theme.subBackground : props.theme.text};

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
